import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";
import Home from "./pages/Home";
import Formation from "./pages/Formation";
import Programme from "./pages/Programme";
import Students from "./pages/Students";
import EspaceEtudiant from "./pages/EspaceEtudiant";
import Positionnement from "./pages/Positionnement";
import SuiviPedagogique from "./pages/SuiviPedagogique";
import LivretAccueil from "./pages/LivretAccueil";
import Employers from "./pages/Employers";
import Contact from "./pages/Contact";
import Planning from "./pages/Planning";
import International from "./pages/International";
import MentionsLegales from "./pages/MentionsLegales";
import PolitiqueConfidentialite from "./pages/PolitiqueConfidentialite";

function App() {
  return (
    <div className="App min-h-screen flex flex-col bg-[#F5F5F5]">
      <BrowserRouter>
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/formation" element={<Formation />} />
            <Route path="/programme" element={<Programme />} />
            <Route path="/planning" element={<Planning />} />
            <Route path="/etudiants" element={<Students />} />
            <Route path="/international" element={<International />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
            <Route path="/espace-etudiant" element={<EspaceEtudiant />} />
            <Route path="/espace-etudiant/positionnement" element={<Positionnement />} />
            <Route path="/espace-etudiant/suivi" element={<SuiviPedagogique />} />
            <Route path="/espace-etudiant/livret-accueil" element={<LivretAccueil />} />
            <Route path="/employeurs" element={<Employers />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
